import { userDetailsApi as api } from './userDetailsApi';
export const addTagTypes = ['user'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes
  })
  .injectEndpoints({
    endpoints: build => ({
      userSignupflowRead: build.query<
        UserSignupflowReadApiResponse,
        UserSignupflowReadApiArg
      >({
        query: queryArg => ({ url: `/user/signupflow/${queryArg.uuid}/` }),
        providesTags: ['user']
      }),
      userSignupflowPartialUpdate: build.mutation<
        UserSignupflowPartialUpdateApiResponse,
        UserSignupflowPartialUpdateApiArg
      >({
        query: queryArg => ({
          url: `/user/signupflow/${queryArg.uuid}/`,
          method: 'PATCH',
          body: queryArg.signupFlow
        }),
        invalidatesTags: ['user']
      }),
      userUserRegionDetailList: build.query<
        UserUserRegionDetailListApiResponse,
        UserUserRegionDetailListApiArg
      >({
        query: queryArg => ({
          url: `/user/user_region_detail/`,
          params: {
            search: queryArg.search,
            ordering: queryArg.ordering,
            limit: queryArg.limit,
            offset: queryArg.offset,
            user_id: queryArg.userId
          }
        }),
        providesTags: ['user']
      }),
      userUserRegionDetailRead: build.query<
        UserUserRegionDetailReadApiResponse,
        UserUserRegionDetailReadApiArg
      >({
        query: queryArg => ({
          url: `/user/user_region_detail/${queryArg.uuid}/`
        }),
        providesTags: ['user']
      }),
      userUsersUpdateLastLogin: build.mutation<
        UserUsersUpdateLastLoginApiResponse,
        UserUsersUpdateLastLoginApiArg
      >({
        query: queryArg => ({
          url: `/user/users/update_last_login/`,
          method: 'POST',
          body: queryArg.user
        }),
        invalidatesTags: ['user']
      })
    }),
    overrideExisting: false
  });
export { injectedRtkApi as enhancedApi };
export type UserSignupflowReadApiResponse = /** status 200 Custom Response */ {
  results: SignupFlowRead;
  ok?: boolean;
  message?: {
    text?: string | null;
    code?: number;
    args?: object | null;
  };
};
export type UserSignupflowReadApiArg = {
  uuid: string;
};
export type UserSignupflowPartialUpdateApiResponse =
  /** status 200 Custom Response */ {
    results: SignupFlowRead;
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type UserSignupflowPartialUpdateApiArg = {
  uuid: string;
  signupFlow: SignupFlowUpdate;
};
export type UserUserRegionDetailListApiResponse =
  /** status 200 Custom Response */ {
    count?: number;
    next?: string | null;
    previous?: string | null;
    results: UserRegionDetailRead;
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type UserUserRegionDetailListApiArg = {
  /** A search term. */
  search?: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
  /** for users local leader and regional director  */
  userId?: string;
};
export type UserUserRegionDetailReadApiResponse =
  /** status 200 Custom Response */ {
    results: UserRegionDetailRead;
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type UserUserRegionDetailReadApiArg = {
  uuid: string;
};
export type UserUsersUpdateLastLoginApiArg = {
  user: {};
};
export type UserUsersUpdateLastLoginApiResponse =
  /** status 200 Custom Response */ {
    count?: number;
    next?: string | null;
    previous?: string | null;
    results: {
      message: string;
    };
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type GroupLite = {
  name: string;
};
export type GroupLiteRead = {
  uuid?: string;
  name: string;
  parent_id?: string;
  display_role_name?: string;
};
export type ProfileList = {
  gender?:
    | ('Male' | 'Female' | 'Prefer not to say' | 'Transgender' | 'Non-Binary')
    | null;
  birth_date?: string | null;
  contact_number?: string | null;
  street_address?: string | null;
  cb_address?: string | null;
  city?: string | null;
  state?: string | null;
  country_origin?: string | null;
  completed_percentage?: number;
  zip_code?: string | null;
  profile_pic?: string;
  cover_pic?: string;
  volunteering_with?: boolean;
  mailing_address_same?: number;
  country_name?: string;
};
export type ProfileListRead = {
  uuid?: string;
  gender?:
    | ('Male' | 'Female' | 'Prefer not to say' | 'Transgender' | 'Non-Binary')
    | null;
  birth_date?: string | null;
  over_18?: string;
  contact_number?: string | null;
  street_address?: string | null;
  cb_address?: string | null;
  city?: string | null;
  state?: string | null;
  country_origin?: string | null;
  completed_percentage?: number;
  zip_code?: string | null;
  profile_pic?: string;
  cover_pic?: string;
  volunteering_with?: boolean;
  mailing_address_same?: number;
  country_name?: string;
};
export type MamaProfile = {
  cb_mamaavail?: ('Active' | 'Paused') | null;
  cb_mamastart?: string | null;
  cb_pausedate?: string | null;
  cb_mamapausenotes?: string | null;
  cb_mamafreq?: string | null;
  cb_mamacap?: number | null;
  cb_mamafillin?: string | null;
  cb_mamaradius?: number | null;
  cb_mamacooks?: string | null;
  cb_mamasmsok?: number | null;
  cb_mamaleader?: string | null;
  cb_mamalat?: string | null;
  cb_mamalon?: string | null;
  cb_mamatzone?: string | null;
  cb_mamamisc?: string | null;
  cb_mamasocial?: string | null;
  cb_mamamatches?: number | null;
  cb_mamadeliveries?: number | null;
  cb_mamalmnotes?: string | null;
  cb_mama1stmatch?: string | null;
  cb_hidedelivered?: string | null;
  cb_mamaradiustype?: string | null;
};
export type MamaProfileRead = {
  uuid?: string;
  cb_mamaavail?: ('Active' | 'Paused') | null;
  cb_mamastart?: string | null;
  cb_pausedate?: string | null;
  cb_mamapausenotes?: string | null;
  cb_mamafreq?: string | null;
  cb_mamacap?: number | null;
  cb_mamafillin?: string | null;
  cb_mamaradius?: number | null;
  cb_mamacooks?: string | null;
  cb_mamasmsok?: number | null;
  cb_mamaleader?: string | null;
  cb_mamalat?: string | null;
  cb_mamalon?: string | null;
  cb_mamatzone?: string | null;
  cb_mamamisc?: string | null;
  cb_mamasocial?: string | null;
  cb_mamamatches?: number | null;
  cb_mamadeliveries?: number | null;
  cb_mamalmnotes?: string | null;
  cb_mama1stmatch?: string | null;
  cb_hidedelivered?: string | null;
  cb_mamaradiustype?: string | null;
};
export type CommunicationPreferences = {
  latest_news_updates?: boolean;
  weekly_goodness_email?: boolean;
  text_notifications?: boolean;
  cb_ll_newsletter?: number | null;
};
export type OtherDetailsProfile = {
  cb_source?: string | null;
  cb_othersource?: string | null;
  cb_employer?: string | null;
  cb_organization?: string | null;
  cb_watchedvideofood?: number | null;
  cb_dateconfirmed?: string | null;
  cb_dateapproved?: string | null;
  cb_leadermatchingcomplete?: number | null;
  cb_leadersentnomatch?: number | null;
  cb_newmatches?: string | null;
  cb_weeksmatches?: number | null;
};
export type OtherDetailsProfileRead = {
  uuid?: string;
  cb_source?: string | null;
  cb_othersource?: string | null;
  cb_employer?: string | null;
  cb_organization?: string | null;
  cb_streetaddress?: string | null;
  cb_watchedvideofood?: number | null;
  cb_dateconfirmed?: string | null;
  cb_dateapproved?: string | null;
};
export type SignupFlow = {
  first_name?: string;
  last_name?: string;
  groups?: GroupLite;
  profile?: ProfileList;
  mamaprofile?: MamaProfile;
  communication_preferences?: CommunicationPreferences;
  other_details?: OtherDetailsProfile;
  /** Designates whether this user should be treated as active. Unselect this instead of deleting accounts. */
  is_active?: boolean;
  date_joined?: string;
};
export type SignupFlowRead = {
  uuid?: string;
  first_name?: string;
  last_name?: string;
  email?: string;
  groups?: GroupLiteRead;
  profile?: ProfileListRead;
  mamaprofile?: MamaProfileRead;
  communication_preferences?: CommunicationPreferences;
  other_details?: OtherDetailsProfileRead;
  /** Designates whether this user should be treated as active. Unselect this instead of deleting accounts. */
  is_active?: boolean;
  date_joined?: string;
  block?: number;
};
export type SignupFlowUpdate = {
  first_name?: string;
  last_name?: string;
  groups?: string | null;
  profile?: ProfileList;
  mamaprofile?: MamaProfile;
  communication_preferences?: CommunicationPreferences;
  other_details?: OtherDetailsProfile;
  /** Designates whether this user should be treated as active. Unselect this instead of deleting accounts. */
  is_active?: boolean;
  date_joined?: string;
  block?: number;
};
export type SignupFlowUpdateRead = {
  uuid?: string;
  first_name?: string;
  last_name?: string;
  email?: string;
  groups?: string | null;
  profile: ProfileListRead;
  mamaprofile?: MamaProfileRead;
  communication_preferences?: CommunicationPreferences;
  other_details: OtherDetailsProfileRead;
  /** Designates whether this user should be treated as active. Unselect this instead of deleting accounts. */
  is_active?: boolean;
  date_joined?: string;
};
export type LeaderLite = {
  first_name?: string;
  last_name?: string;
  email?: string;
};
export type DistrictLeader = {
  name?: string | null;
  lead: LeaderLite[];
};
export type StateDirector = {
  name: string;
  st: string;
  director: LeaderLite[];
};
export type UserRegionDetail = {
  zip: string;
  primary_city?: string | null;
  county?: string | null;
  area_codes?: string | null;
  district: DistrictLeader;
  state: StateDirector;
  country?: string;
};
export type UserRegionDetailRead = {
  uuid?: string;
  zip: string;
  primary_city?: string | null;
  county?: string | null;
  area_codes?: string | null;
  state_code?: string;
  district?: DistrictLeader;
  state?: StateDirector;
  country?: string;
  local_leader?: string;
  regional_director?: string;
};
export const {
  useUserSignupflowReadQuery,
  useUserSignupflowPartialUpdateMutation,
  useUserUserRegionDetailListQuery,
  useUserUserRegionDetailReadQuery,
  useUserUsersUpdateLastLoginMutation
} = injectedRtkApi;
